__turbopack_context__.v({
  "blocksBackgroundColor": "SimplePopupEditor-module-scss-module__z-x7pG__blocksBackgroundColor",
  "blocksFontColor": "SimplePopupEditor-module-scss-module__z-x7pG__blocksFontColor",
  "container": "SimplePopupEditor-module-scss-module__z-x7pG__container",
  "popup": "SimplePopupEditor-module-scss-module__z-x7pG__popup",
  "secondaryNavBackgroundColor": "SimplePopupEditor-module-scss-module__z-x7pG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "SimplePopupEditor-module-scss-module__z-x7pG__themeBackgroundColor",
  "themeFontColor": "SimplePopupEditor-module-scss-module__z-x7pG__themeFontColor",
});
